import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Garage } from '@1po/1po-bff-fe-spec/generated/garage/Garage';
import { RootState } from 'app/AppStore';
import { hasData, NO_DATA } from 'utils';
import {
  fetchGarageInfoRequest,
  getGarageInfo,
  getUserGarageInfo,
  getUserGarageWorkshopId,
  verifyDmsWorkshopIdRequestSaga,
} from './Garage.store';
import { DealerRepository, getDMSConfig, getTradingProfile } from '../user';

export function useFetchCurrentGarageInfo() {
  const dispatch = useDispatch();
  const garageInfo = useSelector(getUserGarageInfo);
  const tradingProfile = useSelector(getTradingProfile);
  const buyerId = tradingProfile?.buyerId;
  const repository = tradingProfile?.repository;
  useEffect(() => {
    if (!garageInfo && buyerId && repository) {
      dispatch(fetchGarageInfoRequest({ garageId: buyerId, repository }));
    }
  }, [dispatch, garageInfo, buyerId, repository]);
}

export function useFetchGarageInfo(garageId: string, repository: DealerRepository): Garage | NO_DATA {
  const dispatch = useDispatch();
  const garageInfo = useSelector((state: RootState) => getGarageInfo(state, garageId));
  useEffect(() => {
    if (garageId && !garageInfo) {
      dispatch(fetchGarageInfoRequest({ garageId, repository }));
    }
  }, [dispatch, garageId, garageInfo, repository]);

  return garageInfo;
}

export const useVerifyConfiguredDmsWorkshopId = () => {
  const dispatch = useDispatch();
  const configuredDmsWorkshopId = useSelector(getUserGarageWorkshopId);
  const complementaryDmsData = useSelector(getDMSConfig)?.complementaryDmsData;
  useEffect(() => {
    if (configuredDmsWorkshopId && !hasData(complementaryDmsData?.searchStatus)) {
      dispatch(verifyDmsWorkshopIdRequestSaga({ workshopId: configuredDmsWorkshopId }));
    }
    // eslint-disable-next-line
  }, [dispatch, configuredDmsWorkshopId]);
};
